export const NEW_RADAR_OPTION = {
  grid: {
    left: "10%",
    right: "10%",
    top: "10%",
    bottom: "10%",
    containLabel: true,
  },
  legend: {
    data: ["客戶名稱", "平均值"],
    // top: 1,
  },
  tooltip: {
    trigger: "item",
  },
  radar: {
    center: ["50%", "52%"],
    radius: "60%",
    indicator: [
      { name: "參與度", max: 5 },
      { name: "購買率", max: 5 },
      { name: "新客率", max: 5 },
      { name: "購物車率", max: 5 },
      { name: "跳出率", max: 5 },
      { name: "初次購買率", max: 5 },
    ],
    axisName: {
      color: "#000",
      fontSize: 14,
      // fontWeight: "bold",
    },
  },
  series: [
    {
      name: "指標比較",
      type: "radar",
      data: [
        {
          value: [3, 3, 3, 3, 3, 3],
          name: "平均值",
          itemStyle: {
            color: "#90c21c",
          },
          lineStyle: {
            color: "#90c21c",
            width: 2,
            type: "dashed",
          },
          areaStyle: {
            color: "rgba(144, 194, 28, 0.15)", // 綠色半透明
          },
        },
        {
          value: [4, 3, 4, 3, 2, 3],
          name: "客戶名稱",
          itemStyle: {
            color: "#5B7FDE",
          },
          lineStyle: {
            color: "#5B7FDE",
            width: 2,
          },
          areaStyle: {
            color: "#5B7FDE",
            opacity: 0.6,
          },
        },
      ],
    },
  ],
};

export const NEW_CLIENT_RATIO_OPTION = {
  tooltip: {
    trigger: "item",
  },
  legend: {
    top: "5%",
    left: "center",
    icon: "circle",
    itemWidth: 8,
    itemHeight: 8,
    textStyle: {
      color: "#4f4f4f",
    },
  },
  series: [
    {
      name: "客群來源",
      type: "pie",
      radius: ["45%", "70%"],
      avoidLabelOverlap: false,
      label: {
        show: true,
        position: "center",
        fontSize: 28,
        fontWeight: "bold",
        color: "#1a1a1a",
        formatter: function (params) {
          // 只顯示新客的數據
          if (params.name === "新客") {
            return "新客比例\n" + (params.value * 100).toFixed(1) + "%";
          }
          return "";
        },
      },
      emphasis: {
        disabled: true,
      },
      labelLine: {
        show: false,
      },
      data: [
        { value: 1048, name: "新客" },
        { value: 735, name: "舊客" },
      ],
      // itemStyle: {
      //   borderRadius: 16,
      // },
    },
  ],
};
